import Phaser from 'phaser'

export default class GameWinScene extends Phaser.Scene{
    constructor(){
        super('game-win-scene')
    }
    init(data){
        this.replayButton = undefined
        this.completeTime = data.completeTime
    }

    preload(){
        this.load.image('gamewinbackground', 'images/gameWin.jpg')
        this.load.image('replaybutton', 'images/replayButton2.jpg')
    }

    create(){
        const gameWidth = this.scale.width * 0.5
        const gameHeight = this.scale.width * 0.5
        this.add.image(gameWidth, gameHeight, 'gamewinbackground')
    
        this.replayButton = this.add.image(gameWidth  - 10,gameHeight + 270, 'replaybutton').setScale(0.2).setInteractive()
        
        this.replayButton.once('pointerup', () => {this.scene.start('knight-game-scene')}, this)

        this.add.text(gameWidth - 160, gameHeight + 100, 'Your time : ', {fontSize : '24px', fill : '#FEFEFE'})
        this.add.text(gameWidth + 20, gameHeight + 100, this.completeTime + ' second', {fontSize : '24px', fill : '#FEFEFE'})
    }
}